import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import ViewListOutlinedIcon from "@mui/icons-material/ViewListOutlined";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

export type SettingsSectionId = "threshold-configs" | "deployment-areas";

interface SettingsSectionNavProps {
  activeSection: SettingsSectionId;
  onSectionChange: (section: SettingsSectionId) => void;
}

export function SettingsSectionNav({ activeSection, onSectionChange }: SettingsSectionNavProps) {
  return (
    <Tabs
      value={activeSection}
      onChange={(_, value: SettingsSectionId) => onSectionChange(value)}
      orientation="vertical"
      aria-label="Settings sections"
      sx={{
        minWidth: 190,
        borderRight: 1,
        borderColor: "divider",
        "& .MuiTab-root": {
          alignItems: "flex-start",
          minHeight: 44,
          textAlign: "left",
          justifyContent: "flex-start",
          minWidth: 0,
          width: "100%",
          px: 1.5,
          "& .MuiTab-iconWrapper": {
            width: 24,
            marginRight: 1,
          },
        },
      }}
    >
      <Tab
        value="threshold-configs"
        label="Thresholds"
        icon={<TuneOutlinedIcon />}
        iconPosition="start"
      />
      <Tab
        value="deployment-areas"
        label="Areas"
        icon={<ViewListOutlinedIcon />}
        iconPosition="start"
      />
    </Tabs>
  );
}
